export const checkAvailablePrizeTypes = settings => {
    if (settings && settings.game_types && settings.game_types.length > 0) {
        let enableMrChampion = false;
        let enablePigBoom = false;
        if (
            settings.game_types.includes("Bingo") &&
            settings.bingo.enable_mr_champion
        ) {
            enableMrChampion = true;
        }
        /*  if (
            settings.game_types.includes("Spins") &&
            settings.spins.enable_mr_champion
        ) {
            enableMrChampion = true;
        } */

        if (
            settings.game_types.includes("Bingo") &&
            settings.bingo.enable_pig_boom
        ) {
            enablePigBoom = true;
        }
        /* if (
            settings.game_types.includes("Spins") &&
            settings.spins.enable_pig_boom
        ) {
            enablePigBoom = true;
        } */

        return {
            mrChampion: enableMrChampion,
            pigBoom: enablePigBoom
        };
    }

    return {
        mrChampion: false,
        pigBoom: false
    };
};
